export default __webpack_public_path__ + "static/media/Brigand's Gloves of the Grasping Wild.c2cf2418.jpg";